import ContractModel from "./contractModel";
import {CoUserModel} from "../common/coUserModel";
import moment from "moment";

export interface BillListStatusModel {
  buyAmt: number; // 금년 총 구매액
  setlAmt: number; // 금년 총 납부액
  nonSetlAmt: number; // 총 미납액
  sellAmt: number; // 금년 총 판매액
  nonReceiptAmt: number; // 총 미수액
}

export interface BillListStatusMonthModel {
  reqAmt: number; // 청구 금액
  reqCount: number; // 청구 건수
  nonReceiptAmt: number; // 미수 금액
  nonReceiptCount: number; // 미수 건수
  setlAmt: number; // 납부 금액
  setlCount: number; // 납부 건수
  nonSetlAmt: number; // 미납 금액
  nonSetlCount: number; // 미납 건수
}

export class BillListHeaderDataModel {
  reqCnt: number = 0;
  reqSum: number = 0;
  setlCnt: number = 0;
  setlSum: number = 0;
  nonSetlCnt: number = 0;
  nonSetlSum: number = 0;
  allNonSetlSum: number = 0;
}

export const billListKey = {
  total: 'total',
  sell: 'sell',
  buy: 'buy',
} as const;
export type BillListKey = keyof typeof billListKey;

export interface BillListSearchModel {
  listType: BillListKey;
  reqYmdFrom: string | undefined;
  reqYmdTo: string | undefined;
  reqdPblsYn: 'Y' | 'N' | undefined;
  setlStatus: '1' | '2' | '3' | '4' | undefined;
}

export interface BillListProps {
  search: BillListSearchModel;
  onCheckedRow?: (data: BillSaveModel) => void;
}

export interface BillFormListProps {
  onCheckedRow?: (data: BillSaveModel) => void;
}

export interface BillListModel {
  reqId: string;
  trdKndCd: string; // 구분
  tgtUserId: string; // 거래 상대 id
  tgtUserNm: string; // 거래 상대 명
  tgtRsrcNm: string; // 대상자원
  reqAmt: number; // 청구금액
  reqYmd: string; // 청구일자
  setlAmt: number; // 납부금액
  payYmd: string; // 납부기한
  txblYn: string; // 세금계산서 상태
  reqdYn: string; // 청구서 발행 여부
}

export interface BillSaveModel {
  reqId?: string;
  cntrNo?: string;
  dgr?: string;
  reqdCd?: number;
  tchgrId?: string;
  reqYmd?: string;
  payYmd?: string;
  trdYmdStart?: string;
  trdYmdEnd?: string;
  reqAmt?: number;
  pblsYn?: 'Y' | 'N';
  txblYn?: 'Y' | 'N';
  encEltrSgntCtt?: string;
  reqdInfo?: BillInfoSaveModel;
  contract?: ContractModel;
  reqdAmount?: ReqdAmountModel;
}

export interface BillInfoSaveModel {
  reqId?: string;
  pwrTrdQnt?: number;
  avgUnitc?: number;
  feeAmt?: number;
  feeRate?: number;
  ldspTrdCd?: number;
  reqdDesc?: string;
}

export interface BillAmountSaveModel {
  reqId?: string;
  powerAmtExcludeYn?: string;
  feeAmtExcludeYn?: string;
  powerAmt?: number;
  feeAmt?: number;
  useYn?: string;
}

export interface ReqdInfoModel {
  reqId?: string;
  pwrTrdQnt?: number;
  avgUnitc?: number;
  feeAmt?: number;
  feeRate?: number;
  ldspTrdCd?: number;
  reqdDesc?: string;
}

export interface ReqdAdjsModel {
  reqId?: string;
  setlTrdNo?: string;
  adjsTrcNo?: string;
  aprDt?: Date;
  vrtlBaccBnkNm?: string;
  vrtlBaccNo?: string;
  svngoNm?: string;
  dpsrNm?: string;
  dpsSchlYmd?: string;

  regrId?: string;
  regDate?: Date;
  chgrId?: string;
  chgDate?: Date;
}

export interface ReqdAmountModel {
  reqId?: string;
  powerAmtExcludeYn?: string;
  feeAmtExcludeYn?: string;
  powerAmt?: number;
  feeAmt?: number;
  useYn?: string;
}

export interface ReqdModel {
  reqId?: string;
  cntrNo?: string;
  dgr?: string;
  contract?: ContractModel;
  reqdInfo?: ReqdInfoModel;
  reqdAdjs?: ReqdAdjsModel;
  reqdAmount?: ReqdAmountModel;
  reqdCd?: number;
  regrId?: string;
  tchgrId?: string;
  tchgrNm?: string;
  reqYmd?: string;
  payYmd?: string;
  trdYmdStart?: string;
  trdYmdEnd?: string;
  reqAmt?: number;
  pblsYn?: string;
  txblYn?: string;
  encEltrSgntCtt?: string; // 암호화 전자서명내용

  setlMhdCd?: number; // 결제방식구분코드 -> 1: 계좌이체(무통장), 2: 카드결제
  setlYmd?: string; // 결제일자
  setlAmt?: number; // 결제금액

  trdKndCd?: number;
  tgtRsrcNm?: string;

  reqdDesc?: string;

}

export interface BillTaxInfoModel {
  provider?: CoUserModel;
  receiver?: CoUserModel;
}

export interface BillDetailProps {
  type: BillListKey;
  reqId: string;
}

export type billPageType = 's' | 'p';
export class BillAdminSearchModel {
  constructor(reqdCd: number, pageType: billPageType) {
    this.emksReqdCd = reqdCd;
    this.pageType = pageType;
  }

  emksReqdCd?: number;
  pageType?: billPageType;

  selectMonth: string = moment().format("YYYYMM");

  reqYmdStdt?: string;
  reqYmdEndt?: string;
  setlSortCd?: number = undefined;
  reqdPblsYn?: string;
  txblYn?: string;
}

export class trdYmd{
  trdYmdStart?: string;
  trdYmdEnd?: string;
}

export class BillModel {
  reqId?: string;
  cntrNo?: string;
  dgr?: string;
  contract?: ContractModel;
  reqdInfo?: ReqdInfoModel;
  reqdAdjs?: ReqdAdjsModel;
  reqdAmount?: ReqdAmountModel;
  reqdCd?: number;
  regrId?: string;
  tchgrId?: string;
  tchgrCplc?: string;
  tchgrEmail?: string;
  reqYmd?: string;
  payYmd?: string;
  reqAmt?: number;
  pblsYn?: string;
  txblYn?: string;
  encEltrSgntCtt?: string; // 암호화 전자서명내용

  setlMhdCd?: number; // 결제방식구분코드 -> 1: 계좌이체(무통장), 2: 카드결제
  setlYmd?: string; // 결제일자
  setlAmt?: number; // 결제금액

  trdYmdStart?: string;
  trdYmdEnd?: string;

  trdKndCd?: number;
  tgtRsrcNm?: string;
  pageType?: billPageType;

  taxInfo?: BillTaxInfoModel;
  salerInfo?: CoUserModel;
  pchsrInfo?: CoUserModel;

  // 결제 후 정보
  // 거래번호,

  constructor(data?: Partial<BillModel>) {
    Object.assign(this, data)
  }

  static fromMap(data: Record<string, any>): BillModel {
    return new BillModel(data)
  }
}

export class BillUpdatePaidStatus {
  regrId?: string;
  reqId?: string;
  setlYmd?: string;
  paidYn?: string; // 변경할 결제여부 상태값
}